import React, { Component } from 'react';
import PageTitle from '../home/PageTitle';
import LocalStorageHelper from '../../LocalStorageHelper/LocalStorageHelper';
import AgGridComponent from '../common/AgGridComponent';
import PaginationComponent, { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../common/PaginationComponent';
import { createMasterActionColumn, createMasterActiveColumn } from '../../utils/masterGridHelpers';
import {
    buildMasterGridParams,
    LOCATION_SORT_WHITELIST,
    LOCATION_FILTER_WHITELIST,
} from '../../utils/agGridServerHelpers';
import ApiURL from '../../api/ApiURL';
import cogoToast from 'cogo-toast';
import axios from 'axios';

class Location extends Component {
    //constructor lifecycle event
    constructor(props) {
        super(props);
        ////register Handsontable's modules
        //registerAllModules();
        this.state = {
            showModal: false,
            showDeleteWarnModal: false,
            tcData: [],
            locationData: [],
            isTableLoading: true,
            currentPage: 1,
            pageSize: DEFAULT_PAGE_SIZE,
            totalRecords: 0,
            columnDefs: [],
            sortModel: [],
            filterModel: {},
            travelCircuitId: 0,
            locationId: 0,
            locationName: '',
            userId: 0,
            userRole: '',
            isActive: true
        };
    }
    //componentDidMount lifecycle event
    componentDidMount() {
        window.scroll(0, 0);
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                userId: userData.UserId,
                userRole: userData.RoleName,
                displayName: userData.DisplayName
            })
        }
        this.getAllTCData();
        this.getAllLocationData();
        this.getAllDataColumns();
    }
    //Data Reload
    handleReload = () => this.setState({ currentPage: 1 }, this.getAllLocationData);
    handleSortChange = (sortModel) => {
        this.setState({ sortModel, currentPage: 1 }, this.getAllLocationData);
    };
    handleFilterChange = (filterModel) => {
        this.setState({ filterModel, currentPage: 1 }, this.getAllLocationData);
    };
    handlePageChange = (page) => {
        this.setState({ currentPage: page }, this.getAllLocationData);
    };
    handlePageSizeChange = (size) => {
        this.setState({ pageSize: size, currentPage: 1 }, this.getAllLocationData);
    };
    //Reset all input fields into the modal
    resetInputFields = () => {
        this.setState({
            showModal: false,
            showDeleteWarnModal: false,
            travelCircuitId: 0,
            locationId: 0,
            locationName: '',
            isActive: true
        });
    }
    //Open modal
    openModal = () => this.setState({ showModal: true });
    //Close modal
    closeModal = () => this.setState({ showModal: false });
    //Open Delete warning modal
    openWarnModal = () => this.setState({ showDeleteWarnModal: true });
    //Close Delete warning modal
    closeWarnModal = () => this.setState({ showDeleteWarnModal: false });
    //OnChangeHandler
    handleChange = (e) => {
        console.log(e.target.checked);
        if (e.target.name === 'isActive') {
            this.setState({ [e.target.name]: e.target.checked });
        }
        else {
            this.setState({ [e.target.name]: e.target.value });
        }
    }
    //Get All Travel Circuit Data
    getAllTCData = () => {
        axios
            .get(ApiURL.GetAllTC)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        ...this.state,
                        tcData: dataResult,
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Location data
    getAllLocationData = () => {
        const { currentPage, pageSize, sortModel, filterModel } = this.state;
        const param = buildMasterGridParams(
            currentPage,
            pageSize,
            sortModel,
            filterModel,
            LOCATION_SORT_WHITELIST,
            LOCATION_FILTER_WHITELIST
        );
        this.setState({ isTableLoading: true });
        axios
            .post(ApiURL.GetAllLocation, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        locationData: dataResult.Locations,
                        totalRecords: dataResult?.TotalRecords ?? 0,
                    });
                } else if (respData.StatusCode === 404) {
                    this.setState({ locationData: [], totalRecords: 0 });
                } else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ isTableLoading: false });
            });
    }
    //Get all columns
    getAllDataColumns = () => {
        this.setState({
            columnDefs: [
                createMasterActionColumn(this.getDataItemById, "LocationId"),
                { headerName: "Location", field: "LocationName", flex: 1, minWidth: 140, cellClass: "text-left" },
                { headerName: "Travel Circuit", field: "TravelCircuitName", flex: 1, minWidth: 140, cellClass: "text-left" },
                createMasterActiveColumn(),
            ],
        })
    }
    //Get data by Id
    getDataItemById = (keyData) => {
        var self = this;
        axios
            .get(ApiURL.GetLocationById(keyData))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    console.log(dataResult);
                    self.setState({
                        locationId: dataResult.LocationId,
                        travelCircuitId: dataResult.TravelCircuitId,
                        locationName: dataResult.LocationName,
                        isActive: dataResult.IsActive,
                        showModal: true,
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Handle Add new Record
    handleAddNew = () => {
        this.resetInputFields();
        this.openModal();
    }
    //Delete data by Id
    handleDelete = () => {
        let param = {
            LocationId: this.state.locationId,
            LocationName: this.state.locationName,
            TravelCircuitId: this.state.travelCircuitId,
            UserId: this.state.userId,
            IsActive: false
        };
        axios.post(ApiURL.SaveLocation, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    cogoToast.success("Location deleted successfully!", { position: "bottom-center" });
                    this.resetInputFields();
                    this.closeWarnModal();
                    this.getAllLocationData();
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //save data
    handleSubmit = (e) => {
        e.preventDefault();
        const { travelCircuitId, locationId, locationName, userId, isActive } = this.state;
        if (travelCircuitId === '0') {
            cogoToast.error("Travel Circuit is required!", { position: "bottom-center" });
        }
        else if (locationName === '') {
            cogoToast.error("Location name is required", { position: "bottom-center" });
        }
        else {
            let param = {
                LocationId: locationId,
                LocationName: locationName,
                TravelCircuitId: travelCircuitId,
                UserId: userId,
                isActive: isActive
            };
            console.log(param);
            axios
                .post(ApiURL.SaveLocation, param)
                .then((response) => {
                    let respData = response.data;
                    if (respData.StatusCode === 200) {
                        cogoToast.success("Location saved successfully!", { position: "bottom-center" });
                        this.resetInputFields();
                        this.getAllLocationData();
                    }
                    else if (respData.StatusCode === 500) {
                        cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                    }
                })
                .catch((error) => {
                    cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                });
        }
    }
    render() {
        const { tcData, locationData, showModal, showDeleteWarnModal, columnDefs, travelCircuitId,
            locationId, locationName, isActive, currentPage, pageSize, totalRecords } = this.state;

        const isAdmin = this.state.userRole === 'admin';
        const isEnabled = isAdmin && isActive && locationId > 0;

        return (
            <>
                <div className="master-page">
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
                        <div className="col-md-9 justify-content-start">
                            <PageTitle Title="Manage Location" />
                        </div>
                        <div className="col-md-3 text-right pt-1">
                            <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh" onClick={this.handleReload}>
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                            </button>
                            <button className="btn btn-outline-primary btn-sm px-3 cursor-pointer" title="Add" onClick={this.handleAddNew}>
                                <i className="fa-solid fa-plus"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className="master-page__body">
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalRecords / pageSize) || 1}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
                        onPageChange={this.handlePageChange}
                        onPageSizeChange={this.handlePageSizeChange}
                    />
                    <div className="master-page__grid">
                        <AgGridComponent
                            columnDefs={columnDefs}
                            rowData={locationData}
                            isLoading={this.state.isTableLoading}
                            onSortChange={this.handleSortChange}
                            onFilterChange={this.handleFilterChange}
                            fillHeight
                        />
                    </div>
                </div>
                </div>

                {/* <!----------------- modal section----------------> */}
                <div className={showModal === true ? "modal show-modal  modalWrapper" : "modal"} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title ">{locationId <= 0 ? `Add Location` : `Update Location`}</h1>
                                <i className="fa-regular fa-circle-xmark text-danger" data-bs-dismiss="modal" onClick={this.closeModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        <label className="form-label text-sm">Travelcircuit *</label>
                                        <select
                                            name="travelCircuitId"
                                            value={travelCircuitId}
                                            className="form-control-sm border border-primary form-select w-100"
                                            onChange={this.handleChange}
                                        >
                                            <option value="0">-- Select --</option>
                                            {tcData.map((item, index) => (
                                                <option key={index} value={item.TravelCircuitId}>
                                                    {item.TravelCircuitName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <label className="form-label text-sm">Location Name *</label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="locationName"
                                            value={locationName}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    {/* <div className="col-md-6 mb-2">
                                        <label className="form-label text-sm">Active Status</label>
                                        <input type="checkbox"
                                            className="form-control-sm border border-primary w-100"
                                            name="isActive"
                                            checked={isActive}
                                            onChange={this.handleChange}
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button
                                    type="submit"
                                    className="btn btn-success button-box-shadow"
                                    onClick={this.handleSubmit}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> Save
                                </button>
                                < button
                                    type="button"
                                    className={`btn btn-danger button-box-shadow curser-pointer ${isEnabled ? '' : 'disabled'}`}
                                    onClick={() => { isEnabled && this.openWarnModal() }}
                                >
                                    <i className="fa-solid fa-trash-can"></i> Delete
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary button-box-shadow"
                                    data-bs-dismiss="modal"
                                    onClick={this.closeModal}
                                >
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div >

                {/* <!------DELETE Warning Modal--------> */}
                < div className={showDeleteWarnModal === true ? "modal show-modal" : "modal"
                }>
                    <div className="modal-dialog modal-dialog-centered modal-md ">
                        <div className="modal-content button-box-shadow">
                            <div className="modal-body">
                                <div className="alert alert-warning d-flex align-items-center" role="alert" >
                                    <i className="fa-solid fa-triangle-exclamation"></i>&nbsp;
                                    <div><strong>Are you sure</strong>, you want to <strong>Delete </strong> it?</div>
                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button
                                    type="button"
                                    className="btn btn-danger button-box-shadow btn-sm"
                                    onClick={this.handleDelete}
                                >
                                    <i className="fa-solid fa-trash-can"></i> Delete
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary button-box-shadow btn-sm"
                                    data-bs-dismiss="modal"
                                    onClick={this.closeWarnModal}
                                >
                                    <i className="fa-solid fa-circle-xmark"></i> Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div >
            </>
        );
    }
}

export default Location;